//웹관리자 출력 전용으로 사용됨.
//import { tanhDependencies } from 'mathjs';
import QRCode from 'qrcode'
import JsBarcode from 'jsbarcode';

class DRComponent {

  //생성자
  constructor(model, matchlist, isPrint){
      
      //객체 주소값으로 사용할 랜덤값
      //this.unikey = this.createRandomValue();
      this.isprint = isPrint;
      this.MATCHTYPELIST = matchlist;
      this.model = model;
      this.model.TEMP_POSX   = this.model.LAYOUT_POSX;
      this.model.TEMP_POSY   = this.model.LAYOUT_POSY;
      this.model.TEMP_WIDTH  = this.model.LAYOUT_WIDTH;
      this.model.TEMP_HEIGHT = this.model.LAYOUT_HEIGHT;
  
      //컬러
      this.temp_div;
      if(model.COMPONENT_TYPE == 0){
        this.temp_div = document.createElement("div");
      }else if(model.COMPONENT_TYPE == 1){
        if(isPrint){
          this.temp_div = document.createElement("div");
          this.temp_div.contentEditable = false;
          this.temp_div.style.verticalAlign = "middle";
          this.temp_div.style.textAlign = "center";
          this.temp_div.style.display = "table-cell";
          this.temp_div.style.lineHeight = "120%";
        }else{
          this.temp_div = document.createElement("div");
          this.temp_div.contentEditable = true;
          this.temp_div.style.verticalAlign = "middle";
          this.temp_div.style.textAlign = "center";
          this.temp_div.style.display = "table-cell";
          this.temp_div.style.lineHeight = "120%";
          this.temp_div.onfocus = this.focuscallback;
          this.temp_div.onblur  = this.focusoutcallback;
        }
      }else{
        this.temp_div = document.createElement("div");
      }

      
      
      this.temp_div.style.pointerEvents = "none"; //마우스 이벤트 무시
      this.temp_div.model = model;                //여기에 객체를 강제로 붙여놓는다. 그래야 이벤트에서 접근됨.
      this.temp_div.MATCHTYPELIST = matchlist;
      
      //커서
      this.temp_div.style.cursor    = "hand";

      //사이즈 위치 관련
      this.temp_div.style.position  = "absolute";
      this.temp_div.style.height    = this.temp_div.model.LAYOUT_HEIGHT + "px";
      this.temp_div.style.width     = this.temp_div.model.LAYOUT_WIDTH  + "px";

      //transform을 사용할 경우 (ROTATE, SCALE 기능이 필요하면 transform 사용)
      this.temp_div.style.transform = "translate("+this.temp_div.model.LAYOUT_POSX+"px, "+this.temp_div.model.LAYOUT_POSY+"px) scale("+this.temp_div.model.SCALE+") rotateZ("+this.temp_div.model.ROTATE+"deg)";


      //텍스트나 이미지는 차일드 div에 추가해야함. 뒤집기 기능 때문에 수정
      let childDiv = this.temp_div.querySelector("div");
      if(childDiv){
        if(model.ISFLIP){
          childDiv.style.transform = "rotate(180deg)";
        }else{
          childDiv.style.transform = "rotate(0deg)";
        }
      }else{
        var child_div = document.createElement("div");
        child_div.style.display = "inline-block";
        if(model.ISFLIP){
          child_div.style.transform = "rotate(180deg)";
        }else{
          child_div.style.transform = "rotate(0deg)";
        }
        this.temp_div.appendChild(child_div);
        childDiv = child_div;
      }

      //배경 처리
      if(model.COMPONENT_TYPE == 0 || model.COMPONENT_TYPE == 1){
        if(this.temp_div.model.BGTYPE == 0){
          //컬러 배경
          this.temp_div.style.backgroundColor = "#"+this.temp_div.model.BGCOLOR;
        }else{
            //이미지 배경
            this.temp_div.style.backgroundSize = this.temp_div.model.LAYOUT_WIDTH + "px " + this.temp_div.model.LAYOUT_HEIGHT + "px";
            //temp_div.style.backgroundSize = "contain"
            childDiv.style.width = "100%";
            childDiv.style.height = "100%";
            childDiv.style.backgroundSize = this.temp_div.model.LAYOUT_WIDTH + "px " + this.temp_div.model.LAYOUT_HEIGHT + "px";
            childDiv.style.backgroundImage = "url('"+this.temp_div.model.IMG+"')"
            childDiv.style.backgroundRepeat = "no-repeat";
            //this.temp_div.style.backgroundImage = "url('"+this.temp_div.model.IMG+"')"
            //this.temp_div.style.backgroundRepeat = "no-repeat";

        }
      }else if(model.COMPONENT_TYPE == 2){
        //QR코드
        if(this.isprint){
          //여기서 QR코드 생성
          this.temp_div.style.backgroundColor = "#ffffff";
          this.temp_div.style.backgroundSize = this.temp_div.model.LAYOUT_WIDTH + "px " + this.temp_div.model.LAYOUT_HEIGHT + "px";
          childDiv.style.width = "100%";
          childDiv.style.height = "100%";
          childDiv.style.backgroundSize = this.temp_div.model.LAYOUT_WIDTH + "px " + this.temp_div.model.LAYOUT_HEIGHT + "px";
          childDiv.style.backgroundRepeat = "no-repeat";
          //this.temp_div.style.backgroundRepeat = "no-repeat";
        }else{
          this.temp_div.style.backgroundColor = "#ffffff";
          this.temp_div.style.backgroundSize = this.temp_div.model.LAYOUT_WIDTH + "px " + this.temp_div.model.LAYOUT_HEIGHT + "px";
          childDiv.style.width = "100%";
          childDiv.style.height = "100%";
          childDiv.style.backgroundSize = this.temp_div.model.LAYOUT_WIDTH + "px " + this.temp_div.model.LAYOUT_HEIGHT + "px";
          childDiv.style.backgroundRepeat = "no-repeat";
          childDiv.style.backgroundImage = `url(${require('../assets/qrsample.png')})`
          //this.temp_div.style.backgroundImage = `url(${require('../assets/qrsample.png')})`
          //this.temp_div.style.backgroundRepeat = "no-repeat";
        }
      }else if(model.COMPONENT_TYPE == 3){
        if(this.isprint){
          //여기서 포토 생성
          this.temp_div.style.backgroundColor = "#ffffff";
          this.temp_div.style.backgroundSize = this.temp_div.model.LAYOUT_WIDTH + "px " + this.temp_div.model.LAYOUT_HEIGHT + "px";
          childDiv.style.width = "100%";
          childDiv.style.height = "100%";
          childDiv.style.backgroundSize = this.temp_div.model.LAYOUT_WIDTH + "px " + this.temp_div.model.LAYOUT_HEIGHT + "px";
          childDiv.style.backgroundRepeat = "no-repeat";
          //this.temp_div.style.backgroundRepeat = "no-repeat";
        }else{
          this.temp_div.style.backgroundColor = "#ffffff";
          this.temp_div.style.backgroundSize = this.temp_div.model.LAYOUT_WIDTH + "px " + this.temp_div.model.LAYOUT_HEIGHT + "px";
          childDiv.style.width = "100%";
          childDiv.style.height = "100%";
          childDiv.style.backgroundSize = this.temp_div.model.LAYOUT_WIDTH + "px " + this.temp_div.model.LAYOUT_HEIGHT + "px";
          childDiv.style.backgroundRepeat = "no-repeat";
          childDiv.style.backgroundImage = `url(${require('../assets/photosample.png')})`
          //this.temp_div.style.backgroundImage = `url(${require('../assets/photosample.png')})`
          //this.temp_div.style.backgroundRepeat = "no-repeat";
        }
      }else if(model.COMPONENT_TYPE == 4){
        //바코드
        if(this.isprint){
          //여기서 QR코드 생성
          this.temp_div.style.backgroundColor = "#ffffff";
          this.temp_div.style.backgroundSize = this.temp_div.model.LAYOUT_WIDTH + "px " + this.temp_div.model.LAYOUT_HEIGHT + "px";
          childDiv.style.width = "100%";
          childDiv.style.height = "100%";
          childDiv.style.backgroundSize = this.temp_div.model.LAYOUT_WIDTH + "px " + this.temp_div.model.LAYOUT_HEIGHT + "px";
          childDiv.style.backgroundRepeat = "no-repeat";
          //this.temp_div.style.backgroundRepeat = "no-repeat";
        }else{
          this.temp_div.style.backgroundColor = "#ffffff";
          this.temp_div.style.backgroundSize = this.temp_div.model.LAYOUT_WIDTH + "px " + this.temp_div.model.LAYOUT_HEIGHT + "px";
          childDiv.style.width = "100%";
          childDiv.style.height = "100%";
          childDiv.style.backgroundSize = this.temp_div.model.LAYOUT_WIDTH + "px " + this.temp_div.model.LAYOUT_HEIGHT + "px";
          childDiv.style.backgroundRepeat = "no-repeat";
          childDiv.style.backgroundImage = `url(${require('../assets/barcodesample.png')})`
          //this.temp_div.style.backgroundImage = `url(${require('../assets/qrsample.png')})`
          //this.temp_div.style.backgroundRepeat = "no-repeat";
        }
      }

      this.temp_div.style.verticalAlign   = "middle";
      this.temp_div.style.fontFamily      = this.temp_div.model.TEXTFONT;
      this.temp_div.style.fontSize        = this.temp_div.model.TEXTSIZE + "px";
      this.temp_div.style.color           = "#"+this.temp_div.model.TEXTCOLOR;
      this.temp_div.style.textAlign       = this.temp_div.model.TEXTALIGN
      this.temp_div.style.verticalAlign   = "middle";
      
      //font size 10px이하 호환하기 (기본적으로 10px이하는 반영이 안됨.)
      this.temp_div.style.webkitTextSizeAdjust = "none";

      //텍스트 줄바꿈
      this.temp_div.style.display         = "flex";
      this.temp_div.style.flexDirection   = "column";
      this.temp_div.style.justifyContent  = "center";
      this.temp_div.style.whiteSpace      = "pre";
      
      //텍스트 값 매칭
      if(isPrint){
        this.setMatchTextValueDiv();
      }else{
        this.setMatchTextValue();
      }
      
      this.temp_div.style.userSelect = "none";  //요걸 해줘야 드래그시 텍스트가 자꾸 드래그 되던 현상이 해결됨.
      this.temp_div.mode = "none"; //이동 및 스케일에 따른 모드

      //이벤트 처리
      this.temp_div.selectflag = false;

      this.temp_div.onkeyup     = this.focusoutevent;

  }

  createQRCODE(target){
    return new Promise(function(resolve, reject) {

      //여기서 QR코드 생성

      //텍스트나 이미지는 차일드 div에 추가해야함. 뒤집기 기능 때문에 수정
      let childDiv = target.temp_div.querySelector("div");
      if(childDiv){
        if(target.temp_div.model.ISFLIP){
          childDiv.style.transform = "rotate(180deg)";
        }else{
          childDiv.style.transform = "rotate(0deg)";
        }
      }else{
        var child_div = document.createElement("div");
        child_div.style.display = "inline-block";
        if(target.temp_div.model.ISFLIP){
          child_div.style.transform = "rotate(180deg)";
        }else{
          child_div.style.transform = "rotate(0deg)";
        }
        this.temp_div.appendChild(child_div);
        childDiv = child_div;
      }
      
      target.temp_div.style.backgroundColor = "#00000000";
      target.temp_div.style.backgroundSize = target.temp_div.model.LAYOUT_WIDTH + "px " + target.temp_div.model.LAYOUT_HEIGHT + "px";
      childDiv.style.width = "100%";
      childDiv.style.height = "100%";
      childDiv.style.backgroundSize = target.temp_div.model.LAYOUT_WIDTH + "px " + target.temp_div.model.LAYOUT_HEIGHT + "px";
      childDiv.style.backgroundRepeat = "no-repeat";
      //target.temp_div.style.backgroundRepeat = "no-repeat";

      if(target.MATCHTYPELIST[21].name){
        QRCode.toDataURL(String(target.MATCHTYPELIST[21].name), { margin:0, width:parseInt(target.temp_div.model.LAYOUT_WIDTH)})
        .then(url=>{
          //console.log("create qr width : " + target.temp_div.model.LAYOUT_WIDTH + " / " + url);
          childDiv.style.backgroundImage = "url('"+url+"')";
          //target.temp_div.style.backgroundImage = "url('"+url+"')";
          resolve(true);
        })
        .catch(error=>{
          console.log("qr error : " + error);
          reject(false);
        });
      }else{
        childDiv.style.backgroundImage = `url(${require('../assets/qrsample.png')})`;
        //target.temp_div.style.backgroundImage = `url(${require('../assets/qrsample.png')})`
      }

    });
  }

  createQRCODETEMP(target){
    return new Promise(function(resolve, reject) {

      //디자인 테스트용 qr생성
      try{

          //텍스트나 이미지는 차일드 div에 추가해야함. 뒤집기 기능 때문에 수정
          let childDiv = target.temp_div.querySelector("div");
          if(childDiv){
            if(target.temp_div.model.ISFLIP){
              childDiv.style.transform = "rotate(180deg)";
            }else{
              childDiv.style.transform = "rotate(0deg)";
            }
          }else{
            var child_div = document.createElement("div");
            child_div.style.display = "inline-block";
            if(target.temp_div.model.ISFLIP){
              child_div.style.transform = "rotate(180deg)";
            }else{
              child_div.style.transform = "rotate(0deg)";
            }
            this.temp_div.appendChild(child_div);
            childDiv = child_div;
          }

        target.temp_div.style.backgroundColor = "#00000000";
        target.temp_div.style.backgroundSize = target.temp_div.model.LAYOUT_WIDTH + "px " + target.temp_div.model.LAYOUT_HEIGHT + "px";
        childDiv.style.width = "100%";
        childDiv.style.height = "100%";
        childDiv.style.backgroundSize = target.temp_div.model.LAYOUT_WIDTH + "px " + target.temp_div.model.LAYOUT_HEIGHT + "px";
        childDiv.style.backgroundImage = `url(${require('../assets/qrsample.png')})`
        childDiv.style.backgroundRepeat = "no-repeat";
        //target.temp_div.style.backgroundImage = `url(${require('../assets/qrsample.png')})`
        //target.temp_div.style.backgroundRepeat = "no-repeat";



        resolve(true);
      }catch(error){
        reject(false);
      }

    });
  }



  createBARCODE(target, value){
    return new Promise(function(resolve, reject) {

      //여기서 바코드 생성
      try{

        //텍스트나 이미지는 차일드 div에 추가해야함. 뒤집기 기능 때문에 수정
        let childDiv = target.temp_div.querySelector("div");
        if(childDiv){
          if(target.temp_div.model.ISFLIP){
            childDiv.style.transform = "rotate(180deg)";
          }else{
            childDiv.style.transform = "rotate(0deg)";
          }
        }else{
          var child_div = document.createElement("div");
          child_div.style.display = "inline-block";
          if(target.temp_div.model.ISFLIP){
            child_div.style.transform = "rotate(180deg)";
          }else{
            child_div.style.transform = "rotate(0deg)";
          }
          this.temp_div.appendChild(child_div);
          childDiv = child_div;
        }
        
        target.temp_div.style.backgroundColor = "#00000000";
        target.temp_div.style.backgroundSize = target.temp_div.model.LAYOUT_WIDTH + "px " + target.temp_div.model.LAYOUT_HEIGHT + "px";
        childDiv.style.width = "100%";
        childDiv.style.height = "100%";
        childDiv.style.backgroundSize = target.temp_div.model.LAYOUT_WIDTH + "px " + target.temp_div.model.LAYOUT_HEIGHT + "px";
        childDiv.style.backgroundRepeat = "no-repeat";
        //target.temp_div.style.backgroundRepeat = "no-repeat";

        //맵핑값이 있어야 하고 혹시나 파싱에러 날 수 있어서 catch함.
        if(value != null && value != undefined && value.length > 0){
          try{
            const canvas = document.createElement('canvas');
            JsBarcode(canvas, value, {format:'CODE39', margin:0, displayValue:false});
            const barcodeDataUrl = canvas.toDataURL("image/png");
            childDiv.style.backgroundImage = `url(${barcodeDataUrl})`;
          }catch(error){
            console.log(error);
          }
        }

        resolve(true);

      }catch(error){
        reject(false);
      }

    });
  }  

  //테스트용
  createBARCODETEMP(target){

    return new Promise(function(resolve, reject) {

      //디자인 테스트용 qr생성
      try{

          //텍스트나 이미지는 차일드 div에 추가해야함. 뒤집기 기능 때문에 수정
          let childDiv = target.temp_div.querySelector("div");
          if(childDiv){
            if(target.temp_div.model.ISFLIP){
              childDiv.style.transform = "rotate(180deg)";
            }else{
              childDiv.style.transform = "rotate(0deg)";
            }
          }else{
            var child_div = document.createElement("div");
            child_div.style.display = "inline-block";
            if(target.temp_div.model.ISFLIP){
              child_div.style.transform = "rotate(180deg)";
            }else{
              child_div.style.transform = "rotate(0deg)";
            }
            this.temp_div.appendChild(child_div);
            childDiv = child_div;
          }

        target.temp_div.style.backgroundColor = "#00000000";
        target.temp_div.style.backgroundSize = target.temp_div.model.LAYOUT_WIDTH + "px " + target.temp_div.model.LAYOUT_HEIGHT + "px";
        childDiv.style.width = "100%";
        childDiv.style.height = "100%";
        childDiv.style.backgroundSize = target.temp_div.model.LAYOUT_WIDTH + "px " + target.temp_div.model.LAYOUT_HEIGHT + "px";
        childDiv.style.backgroundRepeat = "no-repeat";
        //target.temp_div.style.backgroundImage = `url(${require('../assets/qrsample.png')})`
        //target.temp_div.style.backgroundRepeat = "no-repeat";

        const canvas = document.createElement('canvas');
        JsBarcode(canvas, '1234567890', {format:'CODE39', fontSize: 0});
        const barcodeDataUrl = canvas.toDataURL("image/png");
        childDiv.style.backgroundImage = `url(${barcodeDataUrl})`;

        resolve(true);
      }catch(error){
        reject(false);
      }

    });
  }


  createPHOTO(target, photourl){
    //console.log("createPHOTO...1");
    return new Promise(function(resolve, reject) {
      //여기서 포토생성
      try{

        //텍스트나 이미지는 차일드 div에 추가해야함. 뒤집기 기능 때문에 수정
        let childDiv = target.temp_div.querySelector("div");
        if(childDiv){
          if(target.temp_div.model.ISFLIP){
            childDiv.style.transform = "rotate(180deg)";
          }else{
            childDiv.style.transform = "rotate(0deg)";
          }
        }else{
          var child_div = document.createElement("div");
          child_div.style.display = "inline-block";
          if(target.temp_div.model.ISFLIP){
            child_div.style.transform = "rotate(180deg)";
          }else{
            child_div.style.transform = "rotate(0deg)";
          }
          this.temp_div.appendChild(child_div);
          childDiv = child_div;
        }

        target.temp_div.style.backgroundColor = "#00000000";
        target.temp_div.style.backgroundSize = target.temp_div.model.LAYOUT_WIDTH + "px " + target.temp_div.model.LAYOUT_HEIGHT + "px";
        childDiv.style.width = "100%";
        childDiv.style.height = "100%";
        childDiv.style.backgroundSize = target.temp_div.model.LAYOUT_WIDTH + "px " + target.temp_div.model.LAYOUT_HEIGHT + "px";
        childDiv.style.backgroundImage = "url('"+photourl+"')";
        childDiv.style.backgroundRepeat = "no-repeat";

        //target.temp_div.style.backgroundRepeat = "no-repeat";
        //target.temp_div.style.backgroundImage = "url('"+photourl+"')"
        resolve(true);
      }catch(exc){
        reject(false);
      }
    });
  }

  createPHOTOTEMP(target){
    return new Promise(function(resolve, reject) {

      //디자인 테스트용 포토생성
      try{

        //텍스트나 이미지는 차일드 div에 추가해야함. 뒤집기 기능 때문에 수정
        let childDiv = target.temp_div.querySelector("div");
        if(childDiv){
          if(target.temp_div.model.ISFLIP){
            childDiv.style.transform = "rotate(180deg)";
          }else{
            childDiv.style.transform = "rotate(0deg)";
          }
        }else{
          var child_div = document.createElement("div");
          child_div.style.display = "inline-block";
          if(target.temp_div.model.ISFLIP){
            child_div.style.transform = "rotate(180deg)";
          }else{
            child_div.style.transform = "rotate(0deg)";
          }
          this.temp_div.appendChild(child_div);
          childDiv = child_div;
        }

        target.temp_div.style.backgroundColor = "#00000000";
        target.temp_div.style.backgroundSize = target.temp_div.model.LAYOUT_WIDTH + "px " + target.temp_div.model.LAYOUT_HEIGHT + "px";
        childDiv.style.width = "100%";
        childDiv.style.height = "100%";
        childDiv.style.backgroundSize = target.temp_div.model.LAYOUT_WIDTH + "px " + target.temp_div.model.LAYOUT_HEIGHT + "px";
        childDiv.style.backgroundImage = `url(${require('../assets/photosample.png')})`
        childDiv.style.backgroundRepeat = "no-repeat";

        //target.temp_div.style.backgroundImage = `url(${require('../assets/photosample.png')})`
        //target.temp_div.style.backgroundRepeat = "no-repeat";
        resolve(true);
      }catch(error){
        reject(false);
      }

    });
  }

  //유니크값 생성
  createRandomValue(){
      var random = Math.random().toString(16).slice(2,10);
      return '0x'+random;
  }
  
  focuscallback(ev){
    ev.target.style.pointerEvents = "auto";
  }

  focusoutcallback(ev){
    ev.target.style.pointerEvents = "none";
  }
    
  focusoutevent(ev){
    //console.log("onkeyup : " + ev.target.innerText);
    ev.target.model.TEXTVALUE = ev.target.innerText;
    //console.log(ev.target.model.TEXTVALUE);
  }

  setSelected(flag){
    if(flag){
      //this.temp_div.style.border = "2px #00dcf0 solid"
      this.temp_div.selectflag = true;
    }else{
      //this.temp_div.style.border = ""
      this.temp_div.selectflag = false;
    }
  }

  getSelected(){
    return this.temp_div.selectflag;
  }

  //키보드 입력
  setEditMode(target){
    //직접 입력인 경우만 더블클릭으로 입력 가능
    //console.log("setEditMode");
    if(target.model.COMPONENT_TYPE == 1 && target.model.TEXTMATCH == "INPUT"){
      target.style.pointerEvents = "auto"; //마우스 이벤트 처리
      target.focus();
    }
  }


/*******************************************/
// DRBackground가 호출하는 함수
/*******************************************/

  updateComponent(){
    
    this.model.TEMP_POSX   = this.model.LAYOUT_POSX;
    this.model.TEMP_POSY   = this.model.LAYOUT_POSY;
    this.model.TEMP_WIDTH  = this.model.LAYOUT_WIDTH;
    this.model.TEMP_HEIGHT = this.model.LAYOUT_HEIGHT;

    this.temp_div.style.width  = this.model.LAYOUT_WIDTH  + "px";
    this.temp_div.style.height = this.model.LAYOUT_HEIGHT + "px";
    this.temp_div.style.transform = "translate("+this.model.LAYOUT_POSX+"px, "+this.model.LAYOUT_POSY+"px) scale("+this.model.SCALE+") rotateZ("+this.model.ROTATE+"deg)";

    //텍스트나 이미지는 차일드 div에 추가해야함. 뒤집기 기능 때문에 수정
    let childDiv = this.temp_div.querySelector("div");
    if(childDiv){
      if(this.model.ISFLIP){
        childDiv.style.transform = "rotate(180deg)";
      }else{
        childDiv.style.transform = "rotate(0deg)";
      }
    }else{
      var child_div = document.createElement("div");
      child_div.style.display = "inline-block";
      if(this.model.ISFLIP){
        child_div.style.transform = "rotate(180deg)";
      }else{
        child_div.style.transform = "rotate(0deg)";
      }
      this.temp_div.appendChild(child_div);
      childDiv = child_div;
    }

    //배경 처리
    if(this.model.COMPONENT_TYPE == 0 || this.model.COMPONENT_TYPE == 1){
      if(this.model.BGTYPE == 0){
          //컬러 배경
          this.temp_div.style.backgroundColor = "#"+this.model.BGCOLOR;
      }else{
        //이미지 배경
        this.temp_div.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.temp_div.model.LAYOUT_HEIGHT + "px";
        childDiv.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.temp_div.model.LAYOUT_HEIGHT + "px";
        childDiv.style.width = "100%";
        childDiv.style.height = "100%";
        childDiv.style.backgroundImage = "url('"+this.model.IMG+"')"
        childDiv.style.backgroundRepeat = "no-repeat";
      }
    }else if(this.model.COMPONENT_TYPE == 2){
      //QR코드
      if(this.isprint){
        //여기서 QR코드 생성
        //console.log("qr : " + this.MATCHTYPELIST[11]);

      }else{
        this.temp_div.style.backgroundColor = "#ffffff";
        this.temp_div.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.temp_div.model.LAYOUT_HEIGHT + "px";
        childDiv.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.temp_div.model.LAYOUT_HEIGHT + "px";
        childDiv.style.width = "100%";
        childDiv.style.height = "100%";
        childDiv.style.backgroundImage = `url(${require('../assets/qrsample.png')})`
        childDiv.style.backgroundRepeat = "no-repeat";
        //this.temp_div.style.backgroundImage = `url(${require('../assets/qrsample.png')})`
        //this.temp_div.style.backgroundRepeat = "no-repeat";
      }
    }else if(this.model.COMPONENT_TYPE == 3){
      //포토
      if(this.isprint){
        //여기서 QR코드 생성
        console.log("photo : " + this.MATCHTYPELIST[21]);

      }else{
        this.temp_div.style.backgroundColor = "#ffffff";
        this.temp_div.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.temp_div.model.LAYOUT_HEIGHT + "px";
        childDiv.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.temp_div.model.LAYOUT_HEIGHT + "px";
        childDiv.style.width = "100%";
        childDiv.style.height = "100%";
        childDiv.style.backgroundImage = `url(${require('../assets/photosample.png')})`
        childDiv.style.backgroundRepeat = "no-repeat";
        //this.temp_div.style.backgroundImage = `url(${require('../assets/photosample.png')})`
        //this.temp_div.style.backgroundRepeat = "no-repeat";
      }
    }else if(this.model.COMPONENT_TYPE == 4){
      //바코드
      if(this.isprint){
        //여기서 QR코드 생성

      }else{
        this.temp_div.style.backgroundColor = "#ffffff";
        this.temp_div.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.temp_div.model.LAYOUT_HEIGHT + "px";
        childDiv.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.temp_div.model.LAYOUT_HEIGHT + "px";
        childDiv.style.width = "100%";
        childDiv.style.height = "100%";
        childDiv.style.backgroundImage = `url(${require('../assets/barcodesample.png')})`
        childDiv.style.backgroundRepeat = "no-repeat";
        //this.temp_div.style.backgroundImage = `url(${require('../assets/photosample.png')})`
        //this.temp_div.style.backgroundRepeat = "no-repeat";
      }

    }

    this.temp_div.style.fontFamily      = this.model.TEXTFONT;
    this.temp_div.style.fontSize        = this.model.TEXTSIZE + "px";
    this.temp_div.style.color           = "#"+this.model.TEXTCOLOR;
    this.temp_div.style.textAlign       = this.model.TEXTALIGN
    this.setMatchTextValue();
    
  }

  //textmatch에 따른 텍스트값 매칭
  setMatchTextValue(){


    let childDiv = this.temp_div.querySelector("div");
    if(childDiv){
      if(this.model.ISFLIP){
        childDiv.style.transform = "rotate(180deg)";
      }else{
        childDiv.style.transform = "rotate(0deg)";
      }
    }else{
      var temp_span = document.createElement("div");
      temp_span.style.display = "inline-block";
      if(this.model.ISFLIP){
        temp_span.style.transform = "rotate(180deg)";
      }else{
        temp_span.style.transform = "rotate(0deg)";
      }
      this.temp_div.appendChild(temp_span);
      childDiv = temp_span;
    }


    if(this.model.COMPONENT_TYPE == 0){

      //이미지는 텍스트 없음
      childDiv.innerText  = "";

    }else if(this.model.COMPONENT_TYPE == 1){

      if(this.model.TEXTMATCH == "INPUT"){
        childDiv.innerText     = this.model.TEXTVALUE;
      }else if(this.model.TEXTMATCH == "1"){
        childDiv.innerText     = this.MATCHTYPELIST[1].name;
      }else if(this.model.TEXTMATCH == "2"){
        childDiv.innerText     = this.MATCHTYPELIST[2].name;
      }else if(this.model.TEXTMATCH == "3"){
        childDiv.innerText     = this.MATCHTYPELIST[3].name;
      }else if(this.model.TEXTMATCH == "4"){
        childDiv.innerText     = this.MATCHTYPELIST[4].name;
      }else if(this.model.TEXTMATCH == "5"){
        childDiv.innerText     = this.MATCHTYPELIST[5].name;
      }else if(this.model.TEXTMATCH == "6"){
        childDiv.innerText     = this.MATCHTYPELIST[6].name;
      }else if(this.model.TEXTMATCH == "7"){
        childDiv.innerText     = this.MATCHTYPELIST[7].name;
      }else if(this.model.TEXTMATCH == "8"){
        childDiv.innerText     = this.MATCHTYPELIST[8].name;
      }else if(this.model.TEXTMATCH == "9"){
        childDiv.innerText     = this.MATCHTYPELIST[9].name;
      }else if(this.model.TEXTMATCH == "10"){
        childDiv.innerText     = this.MATCHTYPELIST[10].name;
      }else if(this.model.TEXTMATCH == "11"){
        childDiv.innerText     = this.MATCHTYPELIST[11].name;
      }else if(this.model.TEXTMATCH == "12"){
        childDiv.innerText     = this.MATCHTYPELIST[12].name;
      }else if(this.model.TEXTMATCH == "13"){
        childDiv.innerText     = this.MATCHTYPELIST[13].name;
      }else if(this.model.TEXTMATCH == "14"){
        childDiv.innerText     = this.MATCHTYPELIST[14].name;
      }else if(this.model.TEXTMATCH == "15"){
        childDiv.innerText     = this.MATCHTYPELIST[15].name;
      }else if(this.model.TEXTMATCH == "16"){
        childDiv.innerText     = this.MATCHTYPELIST[16].name;
      }else if(this.model.TEXTMATCH == "17"){
        childDiv.innerText     = this.MATCHTYPELIST[17].name;
      }else if(this.model.TEXTMATCH == "18"){
        childDiv.innerText     = this.MATCHTYPELIST[18].name;
      }else if(this.model.TEXTMATCH == "19"){
        childDiv.innerText     = this.MATCHTYPELIST[19].name;
      }else if(this.model.TEXTMATCH == "20"){
        childDiv.innerText     = this.MATCHTYPELIST[20].name;

      }else{
        childDiv.innerText     = "매칭필요"; 
      }

    }else{
      childDiv.innerText     = "";
    }    

  }

  //textmatch에 따른 텍스트값 매칭 - 프린트용
  setMatchTextValueDiv(){

    let childDiv = this.temp_div.querySelector("div");
    if(childDiv){
      if(this.model.ISFLIP){
        childDiv.style.transform = "rotate(180deg)";
      }else{
        childDiv.style.transform = "rotate(0deg)";
      }
    }else{
      var temp_span = document.createElement("div");
      temp_span.style.display = "inline-block";
      if(this.model.ISFLIP){
        temp_span.style.transform = "rotate(180deg)";
      }else{
        temp_span.style.transform = "rotate(0deg)";
      }
      this.temp_div.appendChild(temp_span);
      childDiv = temp_span;
    }


    if(this.model.COMPONENT_TYPE == 0){

      //이미지는 텍스트 없음
      childDiv.innerText  = "";

    }else if(this.model.COMPONENT_TYPE == 1){
      
      if(this.model.TEXTMATCH == "INPUT"){
        childDiv.innerText     = this.model.TEXTVALUE;
      }else if(this.model.TEXTMATCH == "1"){
        childDiv.innerText     = this.MATCHTYPELIST[1].name;
      }else if(this.model.TEXTMATCH == "2"){
        childDiv.innerText     = this.MATCHTYPELIST[2].name;
      }else if(this.model.TEXTMATCH == "3"){
        childDiv.innerText     = this.MATCHTYPELIST[3].name;
      }else if(this.model.TEXTMATCH == "4"){
        childDiv.innerText     = this.MATCHTYPELIST[4].name;
      }else if(this.model.TEXTMATCH == "5"){
        childDiv.innerText     = this.MATCHTYPELIST[5].name;
      }else if(this.model.TEXTMATCH == "6"){
        childDiv.innerText     = this.MATCHTYPELIST[6].name;
      }else if(this.model.TEXTMATCH == "7"){
        childDiv.innerText     = this.MATCHTYPELIST[7].name;
      }else if(this.model.TEXTMATCH == "8"){
        childDiv.innerText     = this.MATCHTYPELIST[8].name;
      }else if(this.model.TEXTMATCH == "9"){
        childDiv.innerText     = this.MATCHTYPELIST[9].name;
      }else if(this.model.TEXTMATCH == "10"){
        childDiv.innerText     = this.MATCHTYPELIST[10].name;
      }else if(this.model.TEXTMATCH == "11"){
        childDiv.innerText     = this.MATCHTYPELIST[11].name;
      }else if(this.model.TEXTMATCH == "12"){
        childDiv.innerText     = this.MATCHTYPELIST[12].name;
      }else if(this.model.TEXTMATCH == "13"){
        childDiv.innerText     = this.MATCHTYPELIST[13].name;
      }else if(this.model.TEXTMATCH == "14"){
        childDiv.innerText     = this.MATCHTYPELIST[14].name;
      }else if(this.model.TEXTMATCH == "15"){
        childDiv.innerText     = this.MATCHTYPELIST[15].name;
      }else if(this.model.TEXTMATCH == "16"){
        childDiv.innerText     = this.MATCHTYPELIST[16].name;
      }else if(this.model.TEXTMATCH == "17"){
        childDiv.innerText     = this.MATCHTYPELIST[17].name;
      }else if(this.model.TEXTMATCH == "18"){
        childDiv.innerText     = this.MATCHTYPELIST[18].name;
      }else if(this.model.TEXTMATCH == "19"){
        childDiv.innerText     = this.MATCHTYPELIST[19].name;
      }else if(this.model.TEXTMATCH == "20"){
        childDiv.innerText     = this.MATCHTYPELIST[20].name;
      }else{
        childDiv.innerText     = "매칭필요"; 
      }
    }else if(this.model.COMPONENT_TYPE == 2){
      childDiv.innerText     = "";
    }else if(this.model.COMPONENT_TYPE == 3){
      childDiv.innerText     = "";
    }else if(this.model.COMPONENT_TYPE == 4){
      childDiv.innerText     = "";
    }else{
      childDiv.innerText     = "";
    }    


  }


  //이동 시작작업
  setMoveStart(target){
    target.model.TEMP_POSX = target.model.LAYOUT_POSX;
    target.model.TEMP_POSY = target.model.LAYOUT_POSY;
  }

  //이동
  setMove(target, mx, my){
    target.model.TEMP_POSX = target.model.TEMP_POSX + mx;
    target.model.TEMP_POSY = target.model.TEMP_POSY + my;
    target.style.transform = "translate("+target.model.TEMP_POSX+"px, "+target.model.TEMP_POSY+"px) scale("+target.model.SCALE+") rotateZ("+target.model.ROTATE+"deg)";
    
    //원본 - 부하 줄이려고 movestart, move end순으로 해서 인포창 갱신 부하 줄인다.
    //target.model.LAYOUT_POSX = target.model.LAYOUT_POSX + mx;
    //target.model.LAYOUT_POSY = target.model.LAYOUT_POSY + my;
    //target.style.transform = "translate("+target.model.LAYOUT_POSX+"px, "+target.model.LAYOUT_POSY+"px) scale("+target.model.SCALE+") rotateZ("+target.model.ROTATE+"deg)";
  }

  //이동끝
  setMoveEnd(target){
    target.model.LAYOUT_POSX = target.model.TEMP_POSX;
    target.model.LAYOUT_POSY = target.model.TEMP_POSY;
  }

  //너비 정하기 (풀사이즈)
  setWidth(w){
    this.temp_div.model.TEMP_WIDTH  = w;
    this.temp_div.style.width  = w + "px";
    this.temp_div.model.TEMP_POSX  = 0;
    this.temp_div.style.transform = "translate("+0+"px, "+this.temp_div.model.LAYOUT_POSY+"px) scale("+this.temp_div.model.SCALE+") rotateZ("+this.temp_div.model.ROTATE+"deg)";
    this.temp_div.model.TEMP_TEXTSIZE = this.temp_div.model.TEXTSIZE;
    this.temp_div.style.backgroundSize = w + "px " + this.temp_div.model.LAYOUT_HEIGHT + "px";

    this.temp_div.model.LAYOUT_POSX   = 0;
    this.temp_div.model.LAYOUT_WIDTH  = w;

  }

  //중앙위치
  centerPos(dispwidth){
    var posx = (dispwidth/2)-(this.temp_div.model.LAYOUT_WIDTH/2);
    this.temp_div.model.TEMP_POSX  = posx;
    this.temp_div.style.transform = "translate("+posx+"px, "+this.temp_div.model.LAYOUT_POSY+"px) scale("+this.temp_div.model.SCALE+") rotateZ("+this.temp_div.model.ROTATE+"deg)";
    this.temp_div.model.LAYOUT_POSX   = posx;
  }

  //스케일 조절
  setSize(target, edit_div, scale, mode, fix){
    var tempw, temph, tempx, tempy, subx, suby = 0;
    //mode에 따라서 고정되는 위치가 달라짐. 여기서는 
    if(mode == "nw"){
      //좌측상단 - 마우스 up을 할때까지는 임시사이즈로 보여준다.
      tempw = Math.floor(target.model.LAYOUT_WIDTH  * scale);
      temph = Math.floor(target.model.LAYOUT_HEIGHT * scale);
      target.model.TEMP_WIDTH  = tempw;
      target.model.TEMP_HEIGHT = temph;
      target.style.width  = tempw + "px";
      target.style.height = temph + "px";
      
      //기준점 대비 좌표 (우측 하단이 기준)
      subx = edit_div.LAYOUT_RIGHT  - target.model.LAYOUT_POSX;
      suby = edit_div.LAYOUT_BOTTOM - target.model.LAYOUT_POSY;
      
      //좌표 계산 - 기준점 대비 좌표값을 계산해야한다.
      tempx = Math.floor(edit_div.LAYOUT_RIGHT  - (subx * scale));
      tempy = Math.floor(edit_div.LAYOUT_BOTTOM - (suby * scale));
      target.model.TEMP_POSX  = tempx;
      target.model.TEMP_POSY  = tempy;

      target.style.transform = "translate("+tempx+"px, "+tempy+"px) scale("+target.model.SCALE+") rotateZ("+target.model.ROTATE+"deg)";
      target.model.TEMP_TEXTSIZE = Math.floor(target.model.TEXTSIZE * scale);
      if(target.model.TEMP_TEXTSIZE < 10){
        target.model.TEMP_TEXTSIZE = 10;
      }
      target.style.fontSize      = target.model.TEMP_TEXTSIZE + "px";
      target.style.backgroundSize = tempw + "px " + temph + "px";
    }else if(mode == "sw"){
      //좌측상단 
      tempw = Math.floor(target.model.LAYOUT_WIDTH  * scale);
      temph = Math.floor(target.model.LAYOUT_HEIGHT * scale);
      
      target.model.TEMP_WIDTH  = tempw;
      target.model.TEMP_HEIGHT = temph;
      target.style.width  = tempw + "px";
      target.style.height = temph + "px";
      
      //기준점 대비 좌표 (우측 상단이 기준)
      subx = edit_div.LAYOUT_RIGHT - target.model.LAYOUT_POSX;
      suby = edit_div.LAYOUT_TOP - target.model.LAYOUT_POSY;

      //좌표 계산 - 기준점 대비 좌표값을 계산해야한다.
      tempx = Math.floor(edit_div.LAYOUT_RIGHT  - (subx * scale));
      tempy = Math.floor(edit_div.LAYOUT_TOP - (suby * scale));
      target.model.TEMP_POSX  = tempx;
      target.model.TEMP_POSY  = tempy;

      target.style.transform = "translate("+tempx+"px, "+tempy+"px) scale("+target.model.SCALE+") rotateZ("+target.model.ROTATE+"deg)";
      target.model.TEMP_TEXTSIZE = Math.floor(target.model.TEXTSIZE * scale);
      if(target.model.TEMP_TEXTSIZE < 10){
        target.model.TEMP_TEXTSIZE = 10;
      }
      target.style.fontSize      = target.model.TEMP_TEXTSIZE + "px";
      target.style.backgroundSize = tempw + "px " + temph + "px";
    }else if(mode == "n"){
      //상단 중앙
      tempw = target.model.LAYOUT_WIDTH;  //그대로
      temph = Math.floor(target.model.LAYOUT_HEIGHT * scale);
      target.model.TEMP_WIDTH  = tempw;
      target.model.TEMP_HEIGHT = temph;
      target.style.width  = tempw + "px";
      target.style.height = temph + "px";
      
      //기준점 대비 컴포넌트 좌표의 거리(하단 중앙이 기준)
      subx = target.model.LAYOUT_POSX;
      suby = edit_div.LAYOUT_BOTTOM - target.model.LAYOUT_POSY;

      //스케일에 따른 좌표 계산 - 기준점 대비 거리에 스케일 처리
      tempx = subx;
      tempy = Math.floor(edit_div.LAYOUT_BOTTOM - (suby * scale));
      target.model.TEMP_POSX  = tempx;
      target.model.TEMP_POSY  = tempy;

      target.style.transform = "translate("+tempx+"px, "+tempy+"px) scale("+target.model.SCALE+") rotateZ("+target.model.ROTATE+"deg)";
      target.model.TEMP_TEXTSIZE = target.model.TEXTSIZE;
      target.style.backgroundSize = tempw + "px " + temph + "px";
    }else if(mode == "s"){
      //하단 중앙
      tempw = target.model.LAYOUT_WIDTH;  //그대로
      temph = Math.floor(target.model.LAYOUT_HEIGHT * scale);
      target.model.TEMP_WIDTH  = tempw;
      target.model.TEMP_HEIGHT = temph;
      target.style.width  = tempw + "px";
      target.style.height = temph + "px";
      
      //기준점 대비 컴포넌트 좌표의 거리(상단 중앙이 기준)
      subx = target.model.LAYOUT_POSX;
      suby = target.model.LAYOUT_POSY - edit_div.LAYOUT_TOP;

      //스케일에 따른 좌표 계산 - 기준점 대비 거리에 스케일 처리
      tempx = subx;
      tempy = Math.floor(edit_div.LAYOUT_TOP + (suby * scale));
      target.model.TEMP_POSX  = tempx;
      target.model.TEMP_POSY  = tempy;

      target.style.transform = "translate("+tempx+"px, "+tempy+"px) scale("+target.model.SCALE+") rotateZ("+target.model.ROTATE+"deg)";
      target.model.TEMP_TEXTSIZE = target.model.TEXTSIZE;
      target.style.backgroundSize = tempw + "px " + temph + "px";
    }else if(mode == "e"){
      //우측 중앙
      tempw = Math.floor(target.model.LAYOUT_WIDTH * scale);
      temph = target.model.LAYOUT_HEIGHT; //그대로
      target.model.TEMP_WIDTH  = tempw;
      target.model.TEMP_HEIGHT = temph;
      target.style.width  = tempw + "px";
      target.style.height = temph + "px";
      
      //기준점 대비 컴포넌트 좌표의 거리(좌측 중앙이 기준)
      subx = target.model.LAYOUT_POSX - edit_div.LAYOUT_LEFT;
      suby = target.model.LAYOUT_POSY;

      //스케일에 따른 좌표 계산 - 기준점 대비 거리에 스케일 처리
      tempx = Math.floor(edit_div.LAYOUT_LEFT + (subx * scale));
      tempy = target.model.LAYOUT_POSY;
      target.model.TEMP_POSX  = tempx;
      target.model.TEMP_POSY  = tempy;

      target.style.transform = "translate("+tempx+"px, "+tempy+"px) scale("+target.model.SCALE+") rotateZ("+target.model.ROTATE+"deg)";
      target.model.TEMP_TEXTSIZE = target.model.TEXTSIZE;
      target.style.backgroundSize = tempw + "px " + temph + "px";
    }else if(mode == "w"){
      //좌측 중앙
      tempw = Math.floor(target.model.LAYOUT_WIDTH * scale);
      temph = target.model.LAYOUT_HEIGHT; //그대로
      target.model.TEMP_WIDTH  = tempw;
      target.model.TEMP_HEIGHT = temph;
      target.style.width  = tempw + "px";
      target.style.height = temph + "px";
      
      //기준점 대비 컴포넌트 좌표의 거리(우측 중앙이 기준) 
      subx = edit_div.LAYOUT_RIGHT - target.model.LAYOUT_POSX;
      suby = target.model.LAYOUT_POSY;

      //스케일에 따른 좌표 계산 - 기준점 대비 거리에 스케일 처리
      tempx = Math.floor(edit_div.LAYOUT_RIGHT - (subx * scale));
      tempy = target.model.LAYOUT_POSY;
      target.model.TEMP_POSX  = tempx;
      target.model.TEMP_POSY  = tempy;

      target.style.transform = "translate("+tempx+"px, "+tempy+"px) scale("+target.model.SCALE+") rotateZ("+target.model.ROTATE+"deg)";
      target.model.TEMP_TEXTSIZE = target.model.TEXTSIZE;
      target.style.backgroundSize = tempw + "px " + temph + "px";
    }else if(mode == "ne"){
      //우측상단
      tempw = Math.floor(target.model.LAYOUT_WIDTH  * scale);
      temph = Math.floor(target.model.LAYOUT_HEIGHT * scale);
      target.model.TEMP_WIDTH  = tempw;
      target.model.TEMP_HEIGHT = temph;
      target.style.width  = tempw + "px";
      target.style.height = temph + "px";
      
      //기준점 대비 좌표 (좌측 하단이 기준)
      subx = edit_div.LAYOUT_LEFT   - target.model.LAYOUT_POSX;
      suby = edit_div.LAYOUT_BOTTOM - target.model.LAYOUT_POSY;

      //좌표 계산 - 기준점 대비 좌표값을 계산해야한다.
      tempx = Math.floor(edit_div.LAYOUT_LEFT   - (subx * scale));
      tempy = Math.floor(edit_div.LAYOUT_BOTTOM - (suby * scale));
      target.model.TEMP_POSX  = tempx;
      target.model.TEMP_POSY  = tempy;

      target.style.transform = "translate("+tempx+"px, "+tempy+"px) scale("+target.model.SCALE+") rotateZ("+target.model.ROTATE+"deg)";
      target.model.TEMP_TEXTSIZE = Math.floor(target.model.TEXTSIZE * scale);
      if(target.model.TEMP_TEXTSIZE < 10){
        target.model.TEMP_TEXTSIZE = 10;
      }
      target.style.fontSize      = target.model.TEMP_TEXTSIZE + "px";
      target.style.backgroundSize = tempw + "px " + temph + "px";
    }else if(mode == "se"){
      //우측하단
      tempw = Math.floor(target.model.LAYOUT_WIDTH  * scale);
      temph = Math.floor(target.model.LAYOUT_HEIGHT * scale);
      target.model.TEMP_WIDTH  = tempw;
      target.model.TEMP_HEIGHT = temph;
      target.style.width  = tempw + "px";
      target.style.height = temph + "px";
      
      //기준점 대비 좌표 (좌측 상단이 기준)
      subx = edit_div.LAYOUT_LEFT - target.model.LAYOUT_POSX;
      suby = edit_div.LAYOUT_TOP  - target.model.LAYOUT_POSY;

      //좌표 계산 - 기준점 대비 좌표값을 계산해야한다.
      tempx = Math.floor(edit_div.LAYOUT_LEFT  - (subx * scale));
      tempy = Math.floor(edit_div.LAYOUT_TOP   - (suby * scale));
      target.model.TEMP_POSX  = tempx;
      target.model.TEMP_POSY  = tempy;

      target.style.transform = "translate("+tempx+"px, "+tempy+"px) scale("+target.model.SCALE+") rotateZ("+target.model.ROTATE+"deg)";
      target.model.TEMP_TEXTSIZE = Math.floor(target.model.TEXTSIZE * scale);
      if(target.model.TEMP_TEXTSIZE < 10){
        target.model.TEMP_TEXTSIZE = 10;
      }
      target.style.fontSize      = target.model.TEMP_TEXTSIZE + "px";
      target.style.backgroundSize = tempw + "px " + temph + "px";
    }

    if(fix){
      //저장
      target.model.LAYOUT_POSX   = tempx;
      target.model.LAYOUT_POSY   = tempy;
      target.model.LAYOUT_WIDTH  = tempw;
      target.model.LAYOUT_HEIGHT = temph;
      target.model.TEXTSIZE      = target.model.TEMP_TEXTSIZE;
    }

  }

  setRotation(target, edit_div, rotate, fix){
    var temp_rotate = rotate;
    var subx, suby = 0;
    
    //edit_div의 중심과 좌표값의 차이를 구한다.
    //기준점 대비 좌표 (좌측 상단이 기준)
    subx = edit_div.LAYOUT_LEFT + (edit_div.LAYOUT_WIDTH/2) - target.model.LAYOUT_POSX;
    suby = edit_div.LAYOUT_TOP + (edit_div.LAYOUT_HEIGHT/2) - target.model.LAYOUT_POSY;
    target.style.transformOrigin = subx+"px "+suby+"px";
    target.style.transform = "translate("+target.model.LAYOUT_POSX+"px, "+target.model.LAYOUT_POSY+"px) scale("+target.model.SCALE+") rotateZ("+temp_rotate+"deg)";
    
    if(fix){
      target.model.ROTATE    = temp_rotate;
      target.model.ORIGIN_X  = subx;
      target.model.ORIGIN_Y  = suby;
    }
  }


}

//해당 js파일에서 DRComponent 클래스를 외부로 export하기 위한 코드
//클래스 외에도 함수나 변수를 외부로 export할 때 사용하며 import나 require로 사용
export default DRComponent;
